import React, { useState, useRef, useEffect } from "react";
import "./DraggableProfilePanel.css";
import { useSelector, useDispatch } from "react-redux";
import { Backdrop, Box, Button, CircularProgress, FormControl, FormHelperText, Grid, MenuItem, Modal, Select, Stack, Table, TableCell, TableRow, Tooltip, Typography } from "@mui/material";
import ErrorModal from "./ErrorModal";
import { storeUserRole, updateCareFacility, updateCareFacilityList } from "../../action";
import { getDefaultCareFacility } from "./Utils";
import { getLoggedInUserDetails, getRoleOfExternalUser, updateCareFacilityAsDefault } from "./constants/globalconstants";
import axiosInstance from "./AxiosInterceptor";

const style = {
  borderRadius: "10px",
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "30%",
  padding: "20px !important",
  bgcolor: "background.paper",
  boxShadow: 24,
  maxHeight: "40%",
  alignItems: "center",
  display: "flex",
  flexDirection: "column",
  gap: "10px",
};

const DraggableProfilePanel = () => {
  const dispatch = useDispatch();
  const [isOpen, setIsOpen] = useState(false);
  const [isDragging, setIsDragging] = useState(false);
  const [profileDetails, setProfileDetails] = useState({});
  const [standAloneList, setStandAloneList] = useState([]);
  const [parentList, setParentList] = useState([]);
  const [childList, setChildList] = useState([]);
  const [showParentName, setShowParentName] = useState(false);
  const [currentCompany, setCurrentCompany] = useState("");
  const [parentCompanyName, setParentCompanyName] = useState("");
  const [showParentCtrl, setShowParentCtrl] = useState(false);
  const [showStandAloneCtrl, setShowStandAloneCtrl] = useState(false);
  const [showChildCtrl, setShowChildCtrl] = useState(false);
  const [disableChild, setDisableChild]= useState(false);
  const [disableSwitch, setDisableSwitch]= useState(true);
  const [disableSwitchOnChange, setDisableSwitchOnChange]= useState(false);
  const [errormodalopen, seterrormodalOpen]= useState(false);
  const [loading, setloading] = useState(false); 
  const [openModal, setOpenModal] = useState(false);
  const [currentCF, setCurrentCF] = useState(currentCompany);
  const storeuser = useSelector((state) => state.storeuser);
  //const parentType= ["Parent"];
  //const standAloneType= ["StandAlone"];
  const types= ["Parent", "StandAlone"];
  //const [types, setTypes] = useState(allTypes);
  const [error, setError] = useState({});
  const [requestFields, setRequestFields] = useState({
    companyType: "",
    parentCompany: "",
    childCompany: "",
    standAloneCompany: "",
  });
  const panelRef = useRef(null);
  const dragOffset = useRef(0);
  const savedPosition = useRef({ top: '50%', transform: 'translateY(-50%)', pixelTop: window.innerHeight * 0.5, isCentered: true });
  const carefacilitydetails = useSelector((state) => state.carefacilitydetails);
  const carefacilitydetailslist = useSelector(
    (state) => state.carefacilitydetailslist
  );

  

  useEffect(() => {
    setProfileDetails(carefacilitydetails);
    setCurrentCompany(carefacilitydetails.careFacilityName);
    if (carefacilitydetails && Object.keys(carefacilitydetails).length > 0) {
      if (carefacilitydetailslist && carefacilitydetailslist.length !== 0) {
        getStandAloneCompanies(carefacilitydetailslist);
        getParentCompanies(carefacilitydetailslist);
//      getChildCompanies(carefacilitydetailslist, "");
        getChildCompanies(carefacilitydetailslist, requestFields.parentCompany);
      }
    }

    if (
      carefacilitydetails.parentCompanyName === null &&
      carefacilitydetails.accountNumber !== ""
    ) {
      setRequestFields({
        ...requestFields,
        companyType: "StandAlone",
        standAloneCompany: carefacilitydetails.careFacilityName,
      });
      setShowParentName(false);
      setShowStandAloneCtrl(true);
      setShowParentCtrl(false);
      setShowChildCtrl(false);
    } else if (
      carefacilitydetails.parentCompanyName === null &&
      carefacilitydetails.accountNumber === ""
    ) {
      setRequestFields({
        ...requestFields,
        parentCompany: carefacilitydetails.careFacilityName,
      });
      setShowParentName(false);
    } else if (
      carefacilitydetails.parentCompanyName !== null &&
      carefacilitydetails.parentCompanyName !== "" &&
      carefacilitydetails.parentId !== 0 &&
      carefacilitydetails.accountNumber !== ""
    ) {
      //setRequestFields({...requestFields, childCompany: carefacilitydetails.careFacilityName});
      setParentCompanyName(carefacilitydetails.parentCompanyName);
      setShowParentName(true);
      setShowParentCtrl(true);
      setShowChildCtrl(true);
      setShowStandAloneCtrl(false);
      setRequestFields({
        ...requestFields,
        companyType: "Parent",
        parentCompany: carefacilitydetails.parentCompanyName,
        childCompany: carefacilitydetails.careFacilityName,
      });      
    }
  }, [carefacilitydetails, carefacilitydetailslist]);


  useEffect(() => {
    if (
      parentCompanyName !== "" &&
      parentCompanyName !== undefined &&
      currentCompany !== "" &&
      currentCompany !== undefined
    ) {   

      if(carefacilitydetailslist && carefacilitydetailslist.length !==0){
        const list = childList.filter(row => 
          row.parentCompanyName.toLowerCase() === parentCompanyName.toLocaleLowerCase()
        );
        setChildList(list);
      }
      setRequestFields({
        ...requestFields,
        companyType: "Parent",
        parentCompany: parentCompanyName,
        childCompany: currentCompany,
      });
    }

    if (
      parentCompanyName === "" ||
      parentCompanyName === null ||
      parentCompanyName === undefined
    ) {
      setRequestFields({
        ...requestFields,
        companyType: "StandAlone",
        standAloneCompany: currentCompany,
      });
    }

    if(requestFields.parentCompany !== ""){
      setDisableChild(false);
    }
  }, [parentCompanyName, currentCompany, carefacilitydetailslist]);


  const getStandAloneCompanies = (carefacilitydetailslist) => {
    const standAloneCompList = carefacilitydetailslist.filter(
      (company) =>
        company.parentCompanyName === null &&
        company.accountNumber !== null &&
        company.accountNumber !== ""
    );
    setStandAloneList(standAloneCompList);
  };

  const getParentCompanies = (carefacilitydetailslist) => {
    const parentCompList = carefacilitydetailslist.filter(
      (company) =>
        company.parentCompanyName === null &&
        company.accountNumber === "" &&
        company.parentId === 0
    );
    setParentList(parentCompList);
  };

  const getChildCompanies = (carefacilitydetailslist, parentComp) => {
    let childCompList = [];
    childCompList = carefacilitydetailslist.filter(
      (company) => company.parentCompanyName !== null && company.parentId !== 0
    );
    setChildList(childCompList);
    if (parentComp !== "" && parentComp !== null) {
      const filteredParent = parentList.filter(
        (row) => row.careFacilityName == parentComp
      );
      const list = childCompList.filter(
        (child) => child.parentId == filteredParent[0].careFacilityId
      );
      setChildList(list);
    }
  };

  const onChange = (e) => {
    setRequestFields({ ...requestFields, [e.target.name]: e.target.value });

    if (e.target.name === "companyType") {
      if (e.target.value === "Parent") {
        setShowParentCtrl(true);
        setShowChildCtrl(true);
        setDisableChild(true);
        setShowStandAloneCtrl(false);
        setRequestFields({ ...requestFields, companyType: "Parent" });


        if(parentList.length === 0 || childList.length === 0 || 
          requestFields.parentCompany === "" || requestFields.childCompany === "" ||
          requestFields.parentCompany === undefined || requestFields.childCompany === undefined ||
          requestFields.childCompany === currentCompany
        ){
          setDisableSwitch(true);
        }
        else{
          setDisableSwitch(false);
        }
       
      } else if (e.target.value === "child") {
        setShowParentCtrl(true);
        setShowChildCtrl(false);
        setShowStandAloneCtrl(false);
        setRequestFields({ ...requestFields, companyType: "child" });
        
      } else if (e.target.value === "StandAlone") {
        setShowStandAloneCtrl(true);
        setShowParentCtrl(false);
        setShowChildCtrl(false);
        setRequestFields({ ...requestFields, companyType: "StandAlone"});


        if(standAloneList.length === 0 || requestFields.standAloneCompany === "" 
          || requestFields.standAloneCompany === undefined
          || requestFields.standAloneCompany === currentCompany){
          setDisableSwitch(true);
        }
        else{
          setDisableSwitch(false);
        }
      }
    }    

    if (e.target.name === "parentCompany") {
      setDisableSwitchOnChange(true);
      setRequestFields({...requestFields,
        companyType: requestFields.companyType,
        parentCompany: e.target.value,
        childCompany: "",
        standAloneCompany: requestFields.standAloneCompany
      })
      getChildCompanies(carefacilitydetailslist, e.target.value);
      setShowChildCtrl(true);      
      setDisableChild(false);
      if(e.target.value){
        setError({...error, parentCompany: ""})
      }

      if(requestFields.childCompany === "" || requestFields.childCompany === undefined
        || requestFields.childCompany === currentCompany
      ){
        setDisableSwitch(true);
      }
      else{
        setDisableSwitch(false);
      }
    }

    if(e.target.name === "childCompany"){
      if(e.target.value){
        setCurrentCF(e.target.value);
        setDisableSwitchOnChange(false);
        setError({...error, childCompany:""})
        if(e.target.value !== currentCompany){
          setDisableSwitch(false);
        }
        else{
          setDisableSwitch(true);
        }
      }
    }

    if(e.target.name === "standAloneCompany"){
      if(e.target.value){
        setCurrentCF(e.target.value);
        setError({...error, standAloneCompany:""})
        if(e.target.value !== currentCompany){
          setDisableSwitch(false);
        }
        else{
          setDisableSwitch(true);
        }
      }
    }
  };

  const toggleAccordion = () => {
    setIsOpen(!isOpen);
  };

  const getUserRoleForDefaultCf = async() =>{
    try {
        const request = {
          userName: storeuser && storeuser.email
        }          
        const response = await axiosInstance.post(`${getRoleOfExternalUser}`,JSON.stringify(request));
        if(response.data.isSuccess && response.data.result){
            dispatch(storeUserRole(response.data.result));
            seterrormodalOpen(false);
          }
        else if(!response.data.isSuccess){
            seterrormodalOpen(true);
          }
        } catch (error) {
          console.log(error.message);
          seterrormodalOpen(true);
        }
      }

  const callApiToMakeDefaultCareFacility = async() =>{
    setloading(true);
    const inputRequest = getCareFacilityId();
    axiosInstance.post(`${updateCareFacilityAsDefault}`,JSON.stringify(inputRequest))
    .then(response =>{
      if(response.data.isSuccess){
        fetchCareFacilityDetails(); 
        getUserRoleForDefaultCf(); 
        seterrormodalOpen(false);
      }
      else if(!response.data.isSuccess){
        seterrormodalOpen(true);
      }
      setloading(false);
    })
    .catch(error =>{
      console.log(error.message);
      seterrormodalOpen(true);
      setloading(false);
    })
  }

  const getCareFacilityId = () =>{
    if(requestFields.companyType === "Parent"){
      setShowStandAloneCtrl(false);
      setShowParentCtrl(true);
      setShowChildCtrl(true);
      const childCompanyList = childList && childList.filter((comp) => 
        comp.careFacilityName.toLowerCase() === requestFields.childCompany.toLowerCase());
      return {
        defaultCareFacilityId : childCompanyList[0].careFacilityId,
        userName : childCompanyList[0].userName
      }
    }
    else if(requestFields.companyType === "StandAlone"){
      setShowParentCtrl(false);
      setShowChildCtrl(false);
      setShowStandAloneCtrl(true);
      const standAloneCompanyList = standAloneList && standAloneList.filter((comp) => 
        comp.careFacilityName.toLowerCase() === requestFields.standAloneCompany.toLowerCase());
      //console.log("standAloneCompany>>",standAloneCompanyList);
      return {
        defaultCareFacilityId : standAloneCompanyList[0].careFacilityId,
        userName : standAloneCompanyList[0].userName
      }
      
    }
    
  }

  const fetchCareFacilityDetails = async() => {
   axiosInstance.get(`${getLoggedInUserDetails}?userName=${storeuser.email}`)
   .then(data => {
    dispatch(updateCareFacilityList(data.data.result));
      const defaultData = getDefaultCareFacility(data.data.result);
      dispatch(updateCareFacility(defaultData));
      setloading(false);
   })
   .catch(error =>{
    console.log("Error occured while getting carefacility details")
    setloading(false);
   })
  }

  const handleSubmit = () => {   
    callApiToMakeDefaultCareFacility();
    setCurrentCF(currentCompany);
    if(requestFields.companyType === "Parent"){
      setShowStandAloneCtrl(false);
      setShowParentCtrl(true);
      setShowChildCtrl(true);
      setCurrentCF(requestFields.childCompany);
    }
    else if(requestFields.companyType === "StandAlone"){
      setShowStandAloneCtrl(true);
      setShowParentCtrl(false);
      setShowChildCtrl(false);
      setParentCompanyName("");
      setCurrentCompany("");
      setCurrentCF(requestFields.standAloneCompany);
    }
    setDisableSwitch(true); 
    setOpenModal(true);
    //setCurrentCompany("");
  };

  const handleMouseDown = (e) => {
    if (!panelRef.current) return;

    const panelRect = panelRef.current.getBoundingClientRect();
    dragOffset.current = e.clientY - panelRect.top;

    // Save current transform style before dragging
    //savedPosition.current.transform = panelRef.current.style.transform;

    //savedPosition.current.top = panelRef.current.style.top;
    savedPosition.current = {
        top: `${panelRect.top}px`,
        transform: panelRef.current.style.transform,
        pixelTop: panelRect.top,
        isCentered: panelRef.current.style.transform.includes('translateY(-50%)')
    };


    setIsDragging(true);
    e.preventDefault();
};


const handleMouseMove = (e) => {
    if (!isDragging || !panelRef.current) return;

    const panelHeight = panelRef.current.offsetHeight;
    let newTop = e.clientY - dragOffset.current;

    // Apply boundaries
    newTop = Math.max(0, Math.min(newTop, window.innerHeight - panelHeight));

    panelRef.current.style.top = `${newTop}px`;
    panelRef.current.style.transform = 'none';
    savedPosition.current.pixelTop = newTop;
    savedPosition.current.isCentered = false;
};

const handleMouseUp = () => {
    if (!isDragging || !panelRef.current) return;

    // Save the final position
    const panelRect = panelRef.current.getBoundingClientRect();
    savedPosition.current = {
        top: panelRef.current.style.top,
        transform: 'none',
        pixelTop: savedPosition.current.pixelTop,
        isCentered: false
    };

    setIsDragging(false);
};

  const onCloseModal =() =>{
    setOpenModal(false);
    window.location.reload();
  }

  useEffect(() => {
    const handleMouseUpGlobal = () => handleMouseUp();


    if (isDragging) {
        window.addEventListener('mousemove', handleMouseMove);
        window.addEventListener('mouseup', handleMouseUpGlobal);
        document.body.style.cursor = 'grabbing';
    }

    return () => {
        window.removeEventListener('mousemove', handleMouseMove);
        window.removeEventListener('mouseup', handleMouseUpGlobal);
        document.body.style.cursor = '';
    };
}, [isDragging]);

  // Apply saved position on mount/resize
  {/*useEffect(() => {
    const panel = panelRef.current;
    //if (!panel) return;
    if(panel && savedPosition.current.top === "50%"){
      const panelHeight = panelRef.current.offsetHeight;
      const centeredTop = (window.innerHeight - panelHeight)/2;
      savedPosition.current.top = `${centeredTop}px`;
      panelRef.current.style.top = savedPosition.current.top;
    }

    //panel.style.top = savedPosition.current.top;
    //panel.style.transform = savedPosition.current.transform;

    const handleResize = () => {
      if (!isDragging && panelRef.current) {
        const panelHeight = panelRef.current.offsetHeight;
        const currentTop = parseFloat(savedPosition.current.top);

        // Adjust position if needed to stay within new viewport bounds
        const boundedTop = Math.max(
          0,
          Math.min(currentTop, window.innerHeight - panelHeight)
        );

        savedPosition.current.top = `${boundedTop}px`;
        panelRef.current.style.top = savedPosition.current.top;
      }
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [isDragging]);*/}

  useEffect(() => {
    const handleResize = () => {
        if (!panelRef.current || isDragging) return;
        const panel = panelRef.current;
        const panelHeight = panel.offsetHeight;

        if (savedPosition.current.isCentered) {
            panel.style.toggleAccordion = '50%';
            panel.style.transform = 'translateY(-50%)';
            savedPosition.current.pixelTop = window.innerHeight * 0.5;
        }
        else {
            const relativePosition = savedPosition.current.pixelTop / window.innerHeight;
            let newPixelTop = relativePosition * window.innerHeight;
            newPixelTop = Math.max(0, Math.min(newPixelTop, window.innerHeight - panelHeight));
            panel.style.top = `${newPixelTop}px`;
            panel.style.transform = 'none';
            savedPosition.current.pixelTop = newPixelTop;
        }
    };
    window.addEventListener('resize', handleResize);
    handleResize();
    return () => window.removeEventListener('resize', handleResize);
}, [isDragging]);


  return (
    <div>
      {loading && (
			<>
			  <Backdrop
				sx={{ color: "white", zIndex: (theme) => theme.zIndex.drawer + 1 }}
				open={true}
			  >
				<CircularProgress sx={{ color: "white" }} />
				<span> &nbsp;&nbsp;&nbsp;&nbsp; Loading Data... </span>
			  </Backdrop>
			</>
		  )}
    <div
      className="accordion-wrapper"
      ref={panelRef}
      style={{
        top: savedPosition.current.top,
        transform: savedPosition.current.transform,
      }}
    >
      <div className={`accordion-container ${isOpen ? "open" : ""}`}>
        <Grid>
        <Grid>
        <div
          className="accordion-header"
          onMouseDown={handleMouseDown}
          style={{ cursor: isDragging ? "grabbing" : "grab" }}
        >
          <h3>Switch Care Facility(CF)</h3>
        </div>
        </Grid>
        <div className="accordion-content">
          <Grid>
            <Table sx={{border:"none"}}>
              <TableRow>
                <TableCell className="table-label-cell">
                Current :
                </TableCell>
                <TableCell className="table-data-cell">
                {currentCompany} 
                </TableCell>
              </TableRow>
              {showParentName &&
              <TableRow>
                <TableCell className="table-label-cell">
                Parent :
                </TableCell>
                <TableCell className="table-data-cell">
                {parentCompanyName}
                </TableCell>
              </TableRow>
              }
            </Table>
          </Grid>
          
          <hr className="content-divider" />
                    
          <Box
          sx={{
            border: "1px solid #bdbdbd",
            borderRadius:"5px",
            padding: "6px"
          }}>
          <Stack
            direction="row"
            alignItems="center"
            rowGap="0.5rem"
            justifyContent="left"
            sx={{ width: "100%", height: "35px", m: "5px 0" }}
          >
            <Box
              display="flex"
              sx={{
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "left",
                width: "90px",
                textAlign: "left",
                float: "left",
              }}
            >
              <p className="comp-type-label">Type</p>
            </Box>
            <Box
              display="flex"
              sx={{
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "space-between",
                minWidth: "198px",
                width: "198px",
              }}
            >
              <FormControl
              defaultValue={requestFields.companyType}
                variant="outlined"
                fullWidth
                margin="normal"
                size="small"
                sx={{
                  "& .MuiInputBase-input": {
                    padding: "2.5px 14px",
                    width: "170px",
                    backgroundColor: "white"
                  },
                }}
              >
                <Select
                  defaultValue={requestFields.companyType}
                  name="companyType"
                  value={requestFields.companyType}
                  onChange={onChange}
                  //displayEmpty
                >
                  {types.map((option)=> (
                    <MenuItem key={option} value={option}>
                      {option}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Box>
          </Stack>

          {showParentCtrl || requestFields.companyType === "Parent" ? (
            <Stack
              direction="row"
              alignItems="center"
              rowGap="0.5rem"
              justifyContent="left"
              sx={{ width: "100%", height: "35px", m: "5px 0" }}
            >
              <Box
                display="flex"
                sx={{
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "left",
                  width: "90px",
                  textAlign: "left",
                  float: "left",
                }}
              >
                <p className="comp-type-label">Parent</p>
              </Box>
              <Box
                display="flex"
                sx={{
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "space-between",
                  minWidth: "170px",
                }}
              >
                
                <FormControl
                error={error.parentCompany}
                  variant="outlined"
                  fullWidth
                  margin="normal"
                  size="small"
                  sx={{
                    "& .MuiInputBase-input": {
                      padding: "2.5px 14px",
                      width: "170px",                      
                      backgroundColor: "white"
                    },
                  }}
                >
                  <Select
                    //disabled={(parentList && parentList.length === 0) || false}
                    name="parentCompany"
                    value={requestFields.parentCompany}
                    onChange={onChange}
                    displayEmpty
                    
                  >
                    {parentList.map((option) => (
                      <MenuItem key={option.id} value={option.careFacilityName}>
                        {option.careFacilityName}
                      </MenuItem>
                    ))}
                  </Select>
                <FormHelperText>{error.parentCompany? error.parentCompany: ""}</FormHelperText>
                </FormControl>
              </Box>
            </Stack>
          ) : null}

          {showChildCtrl || requestFields.companyType === "child" ? (
            <Stack
              direction="row"
              alignItems="center"
              rowGap="0.5rem"
              justifyContent="left"
              sx={{ width: "100%", height: "35px", m: "5px 0" }}
            >
              <Box
                display="flex"
                sx={{
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "left",
                  width: "90px",
                  textAlign: "left",
                  float: "left",
                }}
              >
                <p className="comp-type-label">CF</p>
              </Box>
              <Box
                display="flex"
                sx={{
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "space-between",
                  minWidth: "170px",
                }}
              >
                
                <FormControl
                 error={error.childCompany}
                  variant="outlined"
                  fullWidth
                  margin="normal"
                  size="small"
                  sx={{
                    "& .MuiInputBase-input": {
                      padding: "2.5px 14px",
                      width: "170px",
                      backgroundColor: "white"
                    },
                  }}
                >
                  <Select
                    disabled={disableChild || false}
                    name="childCompany"
                    value={requestFields.childCompany}
                    onChange={onChange}
                    displayEmpty
                  >
                    {childList.map((option) => (
                      <MenuItem key={option.id} value={option.careFacilityName}>
                        {option.careFacilityName}
                      </MenuItem>
                    ))}
                  </Select>
                  <FormHelperText>{error.childCompany? error.childCompany: ""}</FormHelperText>
                </FormControl>
              </Box>
            </Stack>
          ) : null}

          {showStandAloneCtrl || requestFields.companyType === "StandAlone" ? (
            <Stack
              direction="row"
              alignItems="center"
              rowGap="0.5rem"
              justifyContent="left"
              sx={{ width: "100%", height: "35px", m: "5px 0" }}
            >
              <Box
                display="flex"
                sx={{
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "left",
                  width: "90px",
                  textAlign: "left",
                  float: "left",
                }}
              >
                <p className="company-type-label">CF</p>
              </Box>
              <Box
                display="flex"
                sx={{
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "space-between",
                  minWidth: "170px",
                }}
              >
                <FormControl
                  error={error.standAloneCompany}
                  variant="outlined"
                  fullWidth
                  margin="normal"
                  size="small"
                  sx={{
                    "& .MuiInputBase-input": {
                      padding: "2.5px 14px",
                      width: "170px",
                      backgroundColor: "white"
                    },
                  }}
                >
                  <Select
                    //disabled={(standAloneList && standAloneList.length === 0) || false}
                    name="standAloneCompany"
                    value={requestFields.standAloneCompany}
                    onChange={onChange}
                    displayEmpty
                  >
                    {standAloneList.map((option) => (
                      <MenuItem key={option.id} value={option.careFacilityName}>
                        {option.careFacilityName}
                      </MenuItem>
                    ))}
                  </Select>
                  <FormHelperText>{error.standAloneCompany? error.standAloneCompany: ""}</FormHelperText>
                </FormControl>
              </Box>
            </Stack>
          ) : null}
          </Box>

          {/* <div>
                    {showMsg ? showMsg : ""}
                  </div> */}
         
            <div className="submit-button-container">
              
              <Button
               sx={{
                "&.Mui-disabled": {
                  background:"#eaeaea",
                  color: "#c0c0c0"
                }
              }}  
              //disabled={(requestFields.companyType === "Parent" && currentCompany === requestFields.childCompany) || false}
              disabled={disableSwitch || disableSwitchOnChange}
              className="submit-button" 
              onClick={handleSubmit}>
                Switch
              </Button>
             
            </div>

          {/*requestFields.companyType === "StandAlone" &&
          standAloneList &&
          standAloneList.length !== 0 ? (
            <div className="submit-button-container">
              
              <Button
              sx={{
                "&.Mui-disabled": {
                  background:"#eaeaea",
                  color: "#c0c0c0"
                }
              }} 
              //disabled={ (requestFields.companyType === "StandAlone" && currentCompany === requestFields.standAloneCompany) || false}
              disabled={disableSwitch}
              className="submit-button" 
              onClick={handleSubmit}>
                Switch
              </Button>
             
            </div>
          ) : null*/}
        </div>
        </Grid>
        </div>
        <Tooltip
          title="Click to switch Care Facility"
          slotProps={{
            tooltip: {
              sx: {
                backgroundColor: '#fff',
                color: '#3a3a3a',
                border: '1px solid #ccc',
                fontSize:"13px"
              },
            },
            popper: {
              modifiers: [
                {
                  name: 'offset',
                  options: {
                    offset: [0, -12],
                  },
                },
              ],
            },
          }}
      >
      <div
        className="accordion-tab"
        onClick={toggleAccordion}
        style={{ top: "50%", transform: "translateY(-50%)" }}
      >
        <div className="arrow">{isOpen ? "◀" : "▶"}</div>
      </div>
      </Tooltip>
      {errormodalopen && (
			<ErrorModal open={errormodalopen} onClose={() => seterrormodalOpen(false)} />
		  )}

      {openModal && 
      <Modal open={openModal} onClose={onCloseModal}>
      <>
        <Box sx={style}>
          <Typography id="shadow" style={{fontSize:"19px", fontWeight:"150px"}}>
            {" "}
            Switched to {"\""+currentCF+"\""}
          </Typography>
          <Button
            style={{
              width:"100px", 
              height:"35px",
              backgroundColor: "#002d82",
              textTransform: "unset !important",
              paddingRight: "10px",
              marginLeft: "20px",
              marginTop:"5px",
              marginBottom:"5px"}}
            //id="modal-close-btn"
            variant="contained"
            onClick={onCloseModal}
          >
            Ok
          </Button>
        </Box>
      </>
    </Modal>
      }
    </div>
    </div>
  );
};

export default DraggableProfilePanel;
